var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseServerDataTable',{ref:"GridFilter",attrs:{"setting":_vm.setting,"extraParams":_vm.extraParams,"fnDoubleClick":_vm.fnDoubleClick,"fnNew":_vm.fnNew,"fnDelete":_vm.fnDelete}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }